module.exports = __webpack_public_path__ + "img/banner_desktop.fb8fc794.webp";